export default {
	namespaced: true,

	state: {
		// (state) contents -> app
		app: { 
			default_: {
				'new': {
					isDummy: true,

					order: 10
				}
			},
			languages: {
				en: {
					isDefault: true,

					order: 1,
					title: 'English'
				},
				id: {
					order: 2,
					title: 'Bahasa Indonesia'
				},
				ja: {
					order: 3,
					title: '日本語'
				}
			},
			loginOptions: {
				username: {
					order: 10,
					title: 'Username'
				},
				email: {
					order: 20,
					title: 'Email'
				},
				phone: {
					order: 30,
					title: 'Phone'
				}
			},
			menuItems: {
				new: {
					isDummy: true,
					// web menu
					isCollapsedMenu: false,
					isTabMenu: false,
					isToolbarMenu: true,
					// mobile menu
					isMobileMenu: true,

					order: 1,

					title: 'Title',

					icon: 'menu',
					iconColor: null,

					link: {
						to: '/'
					},

					page: {
						name: 'dummy',
						type: 'index'
					},

					menuGroup: {
						all: true
					},

					securityGroup: {
						all: true
					}
				},
				// web menu (and mobile menu)
				tutorial: {
					isDummy: false,
					// web menu
					isCollapsedMenu: false,
					isTabMenu: false,
					isToolbarMenu: true,
					// mobile menu
					isMobileMenu: true,

					order: 20,

					title: 'Tutorial',

					icon: 'help',
					iconColor: null,

					link: {
						url: 'https://hackmd.io/@bo-doc/tutorial'
					},

					menuGroup: {
						all: true
					},

					securityGroup: {
						all: true
					}
				},
				// menu items (collapsed)
				index: {
					isDummy: false,
					// web menu
					isCollapsedMenu: true,
					isTabMenu: false,
					isToolbarMenu: false,
					// mobile menu
					isMobileMenu: true,
					
					menu: {
						menu: true
					},

					order: 10,

					title: 'Home',

					link: {
						to: '/',
						method: {
							name: 'switchMenuGroup',
							params: {
								menuGroup: 'default'
							}
						}
					},

					page: {
						name: 'index',
						type: 'default'
					},

					menuGroup: {
						default: false,
						admin: true,
						point: true,
						recruit: true,
						sales: true,
						training: true
					},

					securityGroup: {
						nonUser: false,
						anonymous: false,
						user: true,
						admin: true
					}
				},
				admin: {
					isDummy: false,
					// web menu
					isCollapsedMenu: true,
					isTabMenu: false,
					isToolbarMenu: false,
					// mobile menu
					isMobileMenu: true,
					
					menu: {
						menu: true
					},

					order: 20,

					title: 'Admin',

					link: {
						to: '/admin',
						method: {
							name: 'switchMenuGroup',
							params: {
								menuGroup: 'admin'
							}
						}
					},

					menuGroup: {
						all: true
					},

					securityGroup: {
						nonUser: false,
						anonymous: false,
						user: false,
						admin: true
					}
				},
				point: {
					isDummy: false,
					// web menu
					isCollapsedMenu: true,
					isTabMenu: false,
					isToolbarMenu: false,
					// mobile menu
					isMobileMenu: true,
					
					menu: {
						menu: true
					},

					order: 30,

					title: 'Point',

					link: {
						to: '/point',
						method: {
							name: 'switchMenuGroup',
							params: {
								menuGroup: 'point'
							}
						}
					},

					menuGroup: {
						default: true
					},

					securityGroup: {
						nonUser: false,
						anonymous: false,
						user: true,
						admin: true
					}
				},
				recruiting: {
					isDummy: false,
					// web menu
					isCollapsedMenu: true,
					isTabMenu: false,
					isToolbarMenu: false,
					// mobile menu
					isMobileMenu: true,
					
					menu: {
						services: true
					},

					tab: {
						serviceForUser: true
					},

					order: 40,

					title: 'Recruit',

					link: {
						to: {
							name: 'page',
							params: {
								pageName: 'recruitCalendar',
								pageType: 'calendar'
							}
						},
						method: {
							name: 'switchMenuGroup',
							params: {
								menuGroup: 'recruit'
							}
						}
					},

					menuGroup: {
						default: true
					},

					securityGroup: {
						nonUser: false,
						anonymous: false,
						user: true,
						admin: true
					}
				},
				sales: {
					isDummy: false,
					// web menu
					isCollapsedMenu: true,
					isTabMenu: false,
					isToolbarMenu: false,
					// mobile menu
					isMobileMenu: true,
					
					menu: {
						services: true
					},

					tab: {
						serviceForUser: true
					},

					order: 50,

					title: 'Sales',

					link: {
						to: {
							name: 'page',
							params: {
								pageName: 'merchantList',
								pageType: 'sheet'
							}
						},
						method: {
							name: 'switchMenuGroup',
							params: {
								menuGroup: 'sales'
							}
						}
					},

					menuGroup: {
						default: true
					},

					securityGroup: {
						nonUser: false,
						anonymous: false,
						user: true,
						admin: true
					}
				},
				training: {
					isDummy: false,
					// web menu
					isCollapsedMenu: true,
					isTabMenu: false,
					isToolbarMenu: false,
					// mobile menu
					isMobileMenu: true,
					
					menu: {
						menu: true
					},

					order: 60,

					title: 'Training',

					link: {
						to: '/training',
						method: {
							name: 'switchMenuGroup',
							params: {
								menuGroup: 'training'
							}
						}
					},

					menuGroup: {
						default: true
					},

					securityGroup: {
						nonUser: false,
						anonymous: false,
						user: true,
						admin: true
					}
				},
				// non user
				login: {
					isDummy: false,
					// web menu
					isCollapsedMenu: true,
					isTabMenu: false,
					isToolbarMenu: false,
					// mobile menu
					isMobileMenu: false,
					
					menu: {
						user: true
					},

					order: 10,

					title: 'Login',

					link: {
						to: '/login'
					},

					menuGroup: {
						all: true
					},

					securityGroup: {
						all: true
					}
				},
				signUp: {
					isDummy: false,
					// web menu
					isCollapsedMenu: true,
					isTabMenu: false,
					isToolbarMenu: false,
					// mobile menu
					isMobileMenu: false,
					
					menu: {
						user: true
					},

					order: 10,

					title: 'Sign Up',

					link: {
						to: '/sign-up'
					},

					menuGroup: {
						all: true
					},

					securityGroup: {
						all: true
					}
				},
				// user
				profile: {
					isDummy: false,
					// web menu
					isCollapsedMenu: false,
					isTabMenu: true,
					isToolbarMenu: false,
					// mobile menu
					isMobileMenu: false,
					
					menu: {
						user: true
					},

					tab: {
						userSetting: true
					},

					order: 10,

					title: 'profile',

					link: {
						to: '/profile'
					},

					menuGroup: {
						all: true
					},

					securityGroup: {
						nonUser: false,
						anonymous: false,
						user: true,
						admin: true
					}
				},
				timeline: {
					isDummy: false,
					// web menu
					isCollapsedMenu: false,
					isTabMenu: true,
					isToolbarMenu: false,
					// mobile menu
					isMobileMenu: false,
					
					menu: {
						user: true
					},

					tab: {
						userSetting: true
					},

					order: 20,

					title: 'Timeline',

					link: {
						to: '/timeline'
					},

					menuGroup: {
						all: true
					},

					securityGroup: {
						nonUser: false,
						anonymous: false,
						user: true,
						admin: true
					}
				},
				logout: {
					isDummy: false,
					// web menu
					isCollapsedMenu: false,
					isTabMenu: true,
					isToolbarMenu: false,
					// mobile menu
					isMobileMenu: false,
					
					menu: {
						user: true
					},

					tab: {
						userSetting: true
					},

					order: 30,

					title: 'Logout',

					link: {
						method: {
							name: 'logout'
						}
					},

					menuGroup: {
						all: true
					},

					securityGroup: {
						nonUser: false,
						anonymous: false,
						user: true,
						admin: true
					}
				},
				// admin menu
				adminUser: {
					isDummy: false,
					// web menu
					isCollapsedMenu: false,
					isTabMenu: true,
					isToolbarMenu: false,
					// mobile menu
					isMobileMenu: false,
					
					menu: {
						user: true
					},

					tab: {
						adminSetting: true
					},

					order: 10,

					title: 'User',

					link: {
						to: {
							name: 'adminOperationType',
							params: {
								operationType: 'user'
							}
						},
						method: {
							name: 'switchMenuGroup',
							params: {
								menuGroup: 'admin'
							}
						}
					},

					menuGroup: {
						all: true
					},

					securityGroup: {
						nonUser: false,
						anonymous: false,
						user: false,
						admin: true
					}
				},
				adminGroup: {
					isDummy: false,
					// web menu
					isCollapsedMenu: false,
					isTabMenu: true,
					isToolbarMenu: false,
					// mobile menu
					isMobileMenu: false,
					
					menu: {
						user: true
					},

					tab: {
						adminSetting: true
					},

					order: 20,

					title: 'Group',

					link: {
						to: {
							name: 'adminOperationType',
							params: {
								operationType: 'group'
							}
						},
						method: {
							name: 'switchMenuGroup',
							params: {
								menuGroup: 'admin'
							}
						}
					},

					menuGroup: {
						all: true
					},

					securityGroup: {
						nonUser: false,
						anonymous: false,
						user: false,
						admin: true
					}
				},
				adminPoint: {
					isDummy: false,
					// web menu
					isCollapsedMenu: false,
					isTabMenu: true,
					isToolbarMenu: false,
					// mobile menu
					isMobileMenu: false,
					
					menu: {
						user: true
					},

					tab: {
						adminSetting: true
					},

					order: 30,

					title: 'Point',

					link: {
						to: {
							name: 'adminOperationType',
							params: {
								operationType: 'point'
							}
						},
						method: {
							name: 'switchMenuGroup',
							params: {
								menuGroup: 'admin'
							}
						}
					},

					menuGroup: {
						all: true
					},

					securityGroup: {
						nonUser: false,
						anonymous: false,
						user: false,
						admin: true
					}
				},
				adminTraining: {
					isDummy: false,
					// web menu
					isCollapsedMenu: false,
					isTabMenu: true,
					isToolbarMenu: false,
					// mobile menu
					isMobileMenu: false,
					
					menu: {
						user: true
					},

					tab: {
						adminSetting: true
					},

					order: 40,

					title: 'Training',

					link: {
						to: {
							name: 'adminOperationType',
							params: {
								operationType: 'training'
							}
						},
						method: {
							name: 'switchMenuGroup',
							params: {
								menuGroup: 'admin'
							}
						}
					},

					menuGroup: {
						all: true
					},

					securityGroup: {
						nonUser: false,
						anonymous: false,
						user: false,
						admin: true
					}
				},
				adminNotification: {
					isDummy: false,
					// web menu
					isCollapsedMenu: false,
					isTabMenu: true,
					isToolbarMenu: false,
					// mobile menu
					isMobileMenu: false,
					
					menu: {
						user: true
					},

					tab: {
						adminSetting: true
					},

					order: 50,

					title: 'Notification',

					link: {
						to: {
							name: 'adminOperationType',
							params: {
								operationType: 'notification'
							}
						},
						method: {
							name: 'switchMenuGroup',
							params: {
								menuGroup: 'admin'
							}
						}
					},

					menuGroup: {
						all: true
					},

					securityGroup: {
						nonUser: false,
						anonymous: false,
						user: false,
						admin: true
					}
				},
				adminIpCli: {
					isDummy: false,
					// web menu
					isCollapsedMenu: false,
					isTabMenu: true,
					isToolbarMenu: false,
					// mobile menu
					isMobileMenu: false,
					
					menu: {
						user: true
					},

					tab: {
						adminSetting: true
					},

					order: 60,

					title: 'Admin(New)',

					link: {
						ipCli: {
							name: 'open'
						}
					},

					menuGroup: {
						all: true
					},

					securityGroup: {
						nonUser: false,
						anonymous: false,
						user: false,
						admin: true
					}
				},
				adminChatWork: {
					isDummy: false,
					// web menu
					isCollapsedMenu: false,
					isTabMenu: true,
					isToolbarMenu: false,
					// mobile menu
					isMobileMenu: false,
					
					menu: {
						user: true
					},

					tab: {
						adminSetting: true
					},

					order: 70,

					title: 'ChatWork(Tasks)',

					link: {
						to: {
							name: 'page',
							params: {
								pageName: 'adminChatWork',
								pageType: 'sheet'
							}
						}
					},

					menuGroup: {
						all: true
					},

					securityGroup: {
						nonUser: false,
						anonymous: false,
						user: false,
						admin: true
					}
				},
				// point
				inputVoucher: {
					isDummy: false,
					// web menu
					isCollapsedMenu: false,
					isTabMenu: true,
					isToolbarMenu: false,
					// mobile menu
					isMobileMenu: true,
					
					menu: {
						user: true
					},

					tab: {
						point: true
					},

					order: 80,

					title: 'Voucher',

					link: {
						method: {
							name: 'pointShowInputVoucherCodeDialog'
						}
					},
					
					menuGroup: {
						point: true
					},

					securityGroup: {
						nonUser: false,
						anonymous: false,
						user: true,
						admin: true
					}
				}
			},
			menuGroups: {
				default: {
					isDefault: true,

					title: 'All Users'
				},
				admin: {
					title: 'Admin'
				},
				point: {
					title: 'Reward Point'
				},
				recruiting: {
					title: 'E-recruiting'
				},
				sales: {
					title: 'Sales Tracking'
				},
				training: {
					title: 'Online Training'
				}
			},
			signUpOptions: {
				email: {
					order: 10,
					title: 'Email'
				},
				phone: {
					order: 20,
					title: 'Phone'
				}
			},
			themes: {
				dark: {
					isDefault: true,
					isDarkTheme: true,

					order: 10,

					title: 'Dark Theme'
				},
				light: {
					isDarkTheme: false,

					order: 20,

					title: 'Light Theme'
				}
			},
			securityGroups: {
				anonymous: {
					order: 10,

					title: 'Anonymous'
				},
				user: {
					order: 20,

					title: 'User'
				},
				admin: {
					order: 30,

					title: 'Admin'
				}
			}
		},
		// (state) contents -> component
		component: { 
			default_: {
				'new': {
					isDummy: true,

					order: 10
				}
			},
			toolbar: {
				menu: {
					isCollapsedMenu: true,
					isTabMenu: false,

					order: 100,
					title: 'Menu',

					icon: null,
					iconColor: null,

					menuGroup: {
						all: true
					},

					securityGroup: {
						admin: true,
						user: true
					}
				},
				user: {
					isCollapsedMenu: false,
					isTabMenu: true,

					order: null,
					title: 'Welcome',

					icon: null,
					iconColor: null,

					menuGroup: {
						all: true
					},

					securityGroup: {
						all: true
					}
				}
			},
			toolbarTabs: {
				// user menu
				userSetting: {
					order: 10,
					title: 'User',

					menu: {
						user: true
					},
					
					menuGroup: {
						all: true
					},
					
					securityGroup: {
						nonUser: false,
						anonymous: false,
						user: true,
						admin: true
					}
				},
				adminSetting: {
					order: 20,
					title: 'Admin',

					menu: {
						user: true
					},
					
					menuGroup: {
						all: true
					},
					
					securityGroup: {
						nonUser: false,
						anonymous: false,
						user: false,
						admin: true
					}
				},
				point: {
					order: 30,
					title: 'Point',

					menu: {
						user: true
					},
					
					menuGroup: {
						point: true
					},
					
					securityGroup: {
						nonUser: false,
						anonymous: false,
						user: true,
						admin: true
					}
				},
				recruting: {
					order: 30,
					title: 'Recruiting',

					menu: {
						user: true
					},
					
					menuGroup: {
						recruiting: true
					},
					
					securityGroup: {
						nonUser: false,
						anonymous: false,
						user: true,
						admin: true
					}
				},
				sales: {
					order: 30,
					title: 'Sales',

					menu: {
						user: true
					},
					
					menuGroup: {
						sales: true
					},
					
					securityGroup: {
						nonUser: false,
						anonymous: false,
						user: true,
						admin: true
					}
				},
				training: {
					order: 30,
					title: 'Training',

					menu: {
						point: true
					},
					
					menuGroup: {
						training: true
					},
					
					securityGroup: {
						nonUser: false,
						anonymous: false,
						user: true,
						admin: true
					}
				}
			}
		},
		// (state) contents -> page
		page: {
			// (state) default pae
			default_: {
				'new': {
					isDummy: true,

					order: 10
				}
			},
			// (state) alert page
			alert_: {
				new: {
					isDummy: true,

					order: 1,

					title: 'Alert Title 1',
					text: 'Alert Text 1',

					type: 'success', // 'info', 'warning'
					icon: null,
					
					actionButtons: {
						key: {
							order: 1,
							title: 'Action',
							link: {
								to: '/'
							}
						}
					}
				}
			},
			// (state) banner page
			banner_: {
				new: {
					isDummy: true,

					order: 1,

					title: 'Banner Title 1',
					text: 'Banner Text 1',

					icon: 'error_outline',

					actionButtons: {
						key: {
							order: 1,
							title: 'Action',
							link: {
								to: '/'
							}
						}
					}
				},
			},
			// (state) calendar page
			calendar_: {
				new: {
					isDummy: true,

					order: 10,

					eventTitle: 'Dummy 1',
					title: 'Dummy Title 1',
					text: 'Dummy Text 1',

					startDate: {
						seconds: 1547056861
					},
					endDate: {
						seconds: 1547056861
					},

					color: 'red',

					actionButtons: {
						key: {
							order: 10,
							title: 'Action 1',
							link: {
								to: '/'
							}
						}
					}
				}
			},
			// (state) card page
			card_: {
				new: {
					isDummy: true,

					order: 1,

					title: 'Card Title 1',
					subTitle: 'Card Sub Title 1',
					text: 'Card Text 1',

					image: {
						url: 'DummyImage'
					},

					actionButtons: {
						key: {
							order: 1,
							title: 'Action 1',
							link: {
								to: '/'
							}
						}
					},

					chips: {
						key: true
					}
				}
			},
			// (state) carousel page
			carousel_: {
				new: {
					isDummy: true,

					order: 1,

					image: {
						url: 'DummyImage'
					},

					video: {
						url: 'DummyVideo',

						loadingImage: 'DummyLoadingImage',
						readyImage: 'DummyReadyImage',

						autoPlay: true,
						controls: false,
						muted: false
					},

					link: {
						to: '/'
					}
				}
			},
			// (state) csv stepper page
			csvStepper_: {
				new: {
					isDummy: true,

					order: 1,

					headerText: 'New',

					isNullable: false,

					dataType: {
						integer: true,
						string: false,
						date: false,
						time: false,
						dateTime: false,
						boolean: false,
						json: false
					}
				}
			},
			// (state) data table page
			dataTable_: {
				new: {
					isDummy: true,

					order: 1,

					title: 'Data Title 1',

					col1: 159,
					col2: 6.0,
					col3: 24,
					col4: 4.0,

					actionButtons: {
						key: {
							order: 1,
							title: 'Action',
							link: {
								to: '/'
							}
						}
					}
				}
			},
			// (state) expansion panel page
			expansionPanel_: {
				new: {
					isDummy: true,

					order: 1,

					title: 'Card Title 1',
					subTitle: 'Card Sub Title 1',
					text: 'Card Text 1',

					image: {
						url: 'DummyImage'
					},

					actionButtons: {
						key: {
							order: 1,
							title: 'Action 1',
							link: {
								to: '/'
							}
						}
					},

					chips: {
						key: true
					}
				}
			},
			// (state) input page
			input_: {
				new: { // checkbox
					isDummy: true,

					order: 10,

					title: 'Section Title',
					text: 'Question1',

					image: {
						url: 'DummyImage'
					},

					actionButtons: {
					// 	key: {
					// 		order: 1,
					// 		title: 'Title',
					// 		link: {
					// 			to: '/'
					// 		}
					// 	}
					},

					type: {
						checkbox: true,
						combobox: false,
						comboboxMultiple: false,
						radioButton: false,
						select: false, // autocomplete component
						selectMultiple: false, // autocomplete component
						slider: false,
						switch: false,
						textarea: false,
						textField: false
					},

					params: {
						appendIcon: null,
						appendOuterIcon: null,
						prependIcon: null,
						prependInnerIcon: null,

						hint: null, // for temporary hint
						message: null, // for persistent hint
						placeholder: 'Placeholder',
						prefix: null,
						suffix: null,

						mask: null, 
						// # -> number
						// a -> small letter
						// A -> big letter
						// n -> number or small letter
						// N -> number or big letter
						// date -> ##/##/####
						// time -> ##:##
						// phone -> (###)###-####
						// credit-card -> ####-####-####-####

						type: null,
						// text
						// number
						// email -> input must include '@'
						// url -> input must begin with 'http(s)://'
						// password -> masked
						// search -> clearable
						// date -> mm/dd/yyyy & calendar (value: yyyy-mm-dd)
						// datetime-local -> mm/dd/yyyy hh:mi AM/PM (value: yyyy-mm-ddThh:mi 24hrs)
						// time -> hh:mi AM/PM (value: hh:mi 24hrs)
						// month -> month yyyy (value: yyyy-mm)
						// hidden -> not shown
					},

					rules: {
						required: false,
						email: false,
						phone: false
					},

					options: {
						key1: {
							order: 10,
							text: 'Checkbox Option1',
							isCorrectAnswer: true
						},
						key2: {
							order: 20,
							text: 'Checkbox Option2',
							isCorrectAnswer: false
						}
					}
				}
			},
			// (state) input with stepper
			inputWithStepper_: {
				new: {
					isDummy: true,

					order: 10,
					
					title: 'Step1 Title',
					text: 'Step1 Text',

					stepNumber: 1,

					nextStepNumber: 2,
					previousStepNumber: null,

					isFirstStep: true,
					isLastStep: false,

					image: {
						url: 'DummyImage'
					},

					actionButtons: {
					//	key: {
					//		order: 10,
					//		title: 'Step1 Action Button Title',
					//		link: {
					//			to: '/'
					//		}
					//	}
					},

					questions: {
						checkbox: {
							order: 10,

							title: 'Section Title',
							text: 'Question1',

							image: {
								url: 'DummyImage'
							},

							actionButtons: {
							// 	key: {
							// 		order: 1,
							// 		title: 'Title',
							// 		link: {
							// 			to: '/'
							// 		}
							// 	}
							},

							type: {
								checkbox: true,
								combobox: false,
								comboboxMultiple: false,
								radioButton: false,
								select: false, // autocomplete component
								selectMultiple: false, // autocomplete component
								slider: false,
								switch: false,
								textarea: false,
								textField: false
							},

							params: {
								appendIcon: null,
								appendOuterIcon: null,
								prependIcon: null,
								prependInnerIcon: null,
	
								hint: null, // for temporary hint
								message: null, // for persistent hint
								placeholder: 'Placeholder',
								prefix: null,
								suffix: null,
	
								mask: null, 
								// # -> number
								// a -> small letter
								// A -> big letter
								// n -> number or small letter
								// N -> number or big letter
								// date -> ##/##/####
								// time -> ##:##
								// phone -> (###)###-####
								// credit-card -> ####-####-####-####
	
								type: null,
								// text
								// number
								// email -> input must include '@'
								// url -> input must begin with 'http(s)://'
								// password -> masked
								// search -> clearable
								// date -> mm/dd/yyyy & calendar (value: yyyy-mm-dd)
								// datetime-local -> mm/dd/yyyy hh:mi AM/PM (value: yyyy-mm-ddThh:mi 24hrs)
								// time -> hh:mi AM/PM (value: hh:mi 24hrs)
								// month -> month yyyy (value: yyyy-mm)
								// hidden -> not shown
							},

							rules: {
								required: false,
								email: false,
								phone: false
							},
							
							options: {
								key1: {
									order: 10,
									text: 'Checkbox Option1',
									isCorrectAnswer: true
								},
								key2: {
									order: 20,
									text: 'Checkbox Option2',
									isCorrectAnswer: false
								}
							},

							score: 10
						},
						radioButton: {
							order: 20,

							title: 'Section Title',
							text: 'Question1',

							image: {
								url: 'DummyImage'
							},

							actionButtons: {
							// 	key: {
							// 		order: 1,
							// 		title: 'Title',
							// 		link: {
							// 			to: '/'
							// 		}
							// 	}
							},

							type: {
								checkbox: false,
								combobox: false,
								comboboxMultiple: false,
								radioButton: true,
								select: false, // autocomplete component
								selectMultiple: false, // autocomplete component
								slider: false,
								switch: false,
								textarea: false,
								textField: false
							},

							params: {
								appendIcon: null,
								appendOuterIcon: null,
								prependIcon: null,
								prependInnerIcon: null,
	
								hint: null, // for temporary hint
								message: null, // for persistent hint
								placeholder: 'Placeholder',
								prefix: null,
								suffix: null,
	
								mask: null, 
								// # -> number
								// a -> small letter
								// A -> big letter
								// n -> number or small letter
								// N -> number or big letter
								// date -> ##/##/####
								// time -> ##:##
								// phone -> (###)###-####
								// credit-card -> ####-####-####-####
	
								type: null,
								// text
								// number
								// email -> input must include '@'
								// url -> input must begin with 'http(s)://'
								// password -> masked
								// search -> clearable
								// date -> mm/dd/yyyy & calendar (value: yyyy-mm-dd)
								// datetime-local -> mm/dd/yyyy hh:mi AM/PM (value: yyyy-mm-ddThh:mi 24hrs)
								// time -> hh:mi AM/PM (value: hh:mi 24hrs)
								// month -> month yyyy (value: yyyy-mm)
								// hidden -> not shown
							},

							rules: {
								required: false,
								email: false,
								phone: false
							},
							
							options: {
								key1: {
									order: 10,
									text: 'Checkbox Option1',
									isCorrectAnswer: true
								},
								key2: {
									order: 20,
									text: 'Checkbox Option2',
									isCorrectAnswer: false
								}
							},

							score: 10
						}
					}
				}
			},
			// (state) sheet page
			sheet_: {
				new: {
					isDummy: true,

					order: 1,

					title: 'Sheet Title 1',
					subTitle: 'Sheet Sub Title 1',
					text: 'Sheet Text 1',

					bigImage: {
						url: 'DummyImage'
					},

					image: {
						url: 'DummyImage'
					},

					video: {
						url: 'DummyVideo',

						loadingImage: 'DummyLoadingImage',
						readyImage: 'DummyReadyImage',

						autoPlay: false,
						controls: false,
						muted: false,

						progressLinearColor: 'primary',

						videoButton: {
							play: true,
							pause: true,
							replay: true,
							minus5Sec: false,
							minus10Sec: true,
							minus30Sec: false,
							plus5Sec: false,
							plus10Sec: true,
							plus30Sec: false,
							halfSpeed: false,
							normalSpeed: false,
							twiceSpeed: false,
							mute: true,
							unmute: true
						}
					},

					bigChart: {
						type: 'column',

						options: null,

						headers: {
							title: {
								order: 1,
								title: 'Title'
							},
							col1: {
								order: 2,	
								title: 'Data 1'
							},
							col2: {
								order: 3,
								title: 'Data 2'
							},
							col3: {
								order: 4,
								title: 'Data 3'
							}
						},
						items: {
							data1: {
								order: 1,
								title: 'Title 1',
								col1: 100,
								col2: 10,
								col3: 1
							},
							data2: {
								order: 2,
								title: 'Title 2',
								col1: 100,
								col2: 10,
								col3: 1
							},
							data3: {
								order: 3,
								title: 'Title 3',
								col1: 100,
								col2: 10,
								col3: 1
							}
						}
					},

					chart: {
						type: 'pie',

						options: null,

						headers: {
							title: {
								order: 1,
								title: 'Title'
							},
							col1: {
								order: 2,	
								title: 'Data 1'
							}
						},
						items: {
							data1: {
								order: 1,
								title: 'Title 1',
								col1: 50,
							},
							data2: {
								order: 2,
								title: 'Title 2',
								col1: 30
							},
							data3: {
								order: 3,
								title: 'Title 3',
								col1: 20
							}
						}
					},

					actionButtons: {
						key: {
							order: 1,
							title: 'Action Button 1',
							link: {
								to: '/'
							}
						}
					}
				}
			},
			// (state) slide group page
			slideGroup_: {
				new: {
					isDummy: true,

					order: 1,

					title: 'Slide Title 1',
					subTitle: 'Slide Sub Title 1',
					text: 'Slide Text 1',

					image: {
						url: 'DummyImage'
					},

					actionButtons: {
						key: {
							order: 1,
							title: 'Action',
							link: {
								to: '/'
							}
						}
					},

					chips: {
						key: true
					}
				}
			},
			// (state) stepper page
			stepper_: {
				new: {
					isDummy: true,

					order: 1,

					title: 'Step1',
					subTitle: 'Step1 Title',
					text: 'Step1 Text',

					stepNumber: 1,

					nextStepNumber: 2,
					previousStepNumber: null,

					isFirstStep: true,
					isLastStep: false,

					image: {
						url: 'DummyImage'
					},

					actionButtons: {
						key: {
							order: 1,
							title: 'Step1 Action',
							link: {
								to: '/'
							}
						}
					}
				}
			},
			// (state) tab page
			tab_: {
				new: {
					isDummy: true,

					order:1,

					tabTitle: 'Tab 1',
					title: 'Title 1',
					subTitle: 'Sub Title 1',
					text: 'Text 1',

					bigImage: {
						url: 'DummyImage'
					},

					image: {
						url: 'DummyImage'
					},

					video: {
						url: 'DummyVideo',

						loadingImage: 'DummyLoadingImage',
						readyImage: 'DummyReadyImage',

						autoPlay: false,
						controls: false,
						muted: false,

						progressLinearColor: 'primary',

						videoButton: {
							play: true,
							pause: true,
							replay: true,
							minus5Sec: false,
							minus10Sec: true,
							minus30Sec: false,
							plus5Sec: false,
							plus10Sec: true,
							plus30Sec: false,
							halfSpeed: false,
							normalSpeed: false,
							twiceSpeed: false,
							mute: true,
							unmute: true
						}
					}
				}
			},
			// (state) treeview page
			treeview_: {
				new: {
					isDummy: true,

					order: 1,

					title: 'Treeview Title 1',
					subTitle: 'Treeview Sub Title 1',
					text: 'Treeview Text 1',

					icon: 'folder',

					image: {
					//	url: 'DummyImage'
					},

					actionButtons: {
						key: {
							order: 1,
							title: 'Action Button 1',
							link: {
								to: '/'
							}
						}
					},

					items: [
						{
							id: 'dummyItem100',
							name: 'Dummy Item 1',

							children: [
								{
									id: 'dummyItem110', 
									name: 'Dummy Item 1 - 1'
								},
								{
									id: 'dummyItem120',
									name: 'Dummy Item 1 - 2',
								},
								{
									id: 'dummyItem130',
									name: 'Dummy Item 1 - 3',

									children: [
										{
											id: 'dummyItem131', 
											name: 'Dummy Item 1 - 3 - 1'
										},
										{
											id: 'dummyItem132',
											name: 'Dummy Item 1 - 3 - 2'
										},
										{
											id: 'dummyItem133',
											name: 'Dummy Item 1 - 3 - 3'
										}
									]
								}
							]
						}
					],

					itemButtons: {
						dummyItem110: {
							top: {
								order: 1,
								title: 'Top',
								link: {
									to: '/'
								}
							},
							web: {
								order: 2,
								title: 'Web',
								link: {
									url: 'https://benefit-one.co.id'
								}
							}
						}
					}
				}
			},
			// (state) window page
			window_: {
				new: {
					isDummy: true,

					order: 1,

					title: 'Sheet Title 1',
					text: 'Sheet Text 1',

					bigImage: {
						url: 'DummyImage'
					},

					image: {
						url: 'DummyImage'
					},

					actionButtons: {
						key: {
							order: 1,
							title: 'Action Button 1',
							link: {
								to: '/'
							}
						}
					}
				}
			},
			// (state) profile
			profile: {
				profilePictureUrl: {
					order: 10,
					title: 'Profile Picture',
					text: 'URL', // for placeholder

					type: 'image',

					editable: true
				},
				uid: {
					order: 20,
					title: 'UID',
					text: null, // for placeholder

					type: 'uid',

					editable: false
				},
				fullName: {
					order: 30,
					title: 'Full Name',
					text: null, // for placeholder

					type: 'text',

					editable: true
				},
				email: {
					order: 40,
					title: 'Email Address',
					text: null, // for placeholder

					type: 'text',

					editable: true
				},
				phone: {
					order: 50,
					title: 'Phone Number',
					text: null, // for placeholder

					type: 'text',

					editable: true
				},
				postcode: {
					order: 60,
					title: 'Postcode',
					text: null, // for placeholder

					type: 'postcode',

					editable: true
				},
				address: {
					order: 70,
					title: 'Address',
					text: null, // for placeholder

					type: 'address',

					editable: false
				},
				address1: {
					order: 70,
					title: 'Address Line 1',
					text: 'Street Number & Name', // for placeholder

					type: 'text',

					editable: true
				},
				address2: {
					order: 80,
					title: 'Address Line 2',
					text: 'Apartment / Suite / Floor', // for placeholder

					type: 'text',

					editable: true
				}
			},
			// (state) recruit
			recruit: {
				new: {
					isDummy: true,

					order: 10
				}
			},
			recruitCalendar: {
				new: {
					isDummy: true,

					order: 10,

					eventTitle: 'Dummy 1',
					title: 'Dummy Title 1',
					text: 'Dummy Text 1',

					startDate: {
						seconds: 1575223261
					},
					endDate: {
						seconds: 1575568861
					},

					color: 'red',

					actionButtons: {
						apply: {
							order: 10,
							title: 'Apply',
							link: {
								to: {
									name: 'page',
									params: {
										pageName: 'dummySchedule1',
										pageType: 'inputRecruit',

										appliedRecruitmentId: 'dummy',
										appliedScheduleId: 'dummySchedule1'
									}
								}
							}
						},
						open: {
							order: 20,
							title: 'Open',
							link: {
								to: {
									name: 'recruit',
									params: {
										recruitmentId: 'dummy'
									}
								}
							}
						}
					}
				}
			},
			recruitApplication: {
				new: {
					isDummy: true,

					order: 10,
				}
			},
			recruitStepInput: {
				new: {
					isDummy: true,

					order: 10,
				}
			},
			recruitInput_: {
				new: { // checkbox
					isDummy: true,

					order: 10,
					title: 'Section Title',
					text: 'Question1',

					image: {
					//	url: 'DummyImage'
					},

					actionButtons: {
					// 	key: {
					// 		order: 1,
					// 		title: 'Title',
					// 		link: {
					// 			to: '/'
					// 		}
					// 	}
					},

					type: {
						checkbox: true,
						combobox: false,
						comboboxMultiple: false,
						radioButton: false,
						select: false, // autocomplete component
						selectMultiple: false, // autocomplete component
						slider: false,
						switch: false,
						textarea: false,
						textField: false
					},

					params: {
						appendIcon: null,
						appendOuterIcon: null,
						prependIcon: null,
						prependInnerIcon: null,

						hint: null, // for temporary hint
						message: null, // for persistent hint
						placeholder: 'Placeholder',
						prefix: null,
						suffix: null,

						mask: null, 
						// # -> number
						// a -> small letter
						// A -> big letter
						// n -> number or small letter
						// N -> number or big letter
						// date -> ##/##/####
						// time -> ##:##
						// phone -> (###)###-####
						// credit-card -> ####-####-####-####

						type: null,
						// text
						// number
						// email -> input must include '@'
						// url -> input must begin with 'http(s)://'
						// password -> masked
						// search -> clearable
						// date -> mm/dd/yyyy & calendar (value: yyyy-mm-dd)
						// datetime-local -> mm/dd/yyyy hh:mi AM/PM (value: yyyy-mm-ddThh:mi 24hrs)
						// time -> hh:mi AM/PM (value: hh:mi 24hrs)
						// month -> month yyyy (value: yyyy-mm)
						// hidden -> not shown
					},

					rules: {
						required: false,
						email: false,
						phone: false
					},

					options: {
						key1: {
							order: 10,
							text: 'Checkbox Option1',
							isCorrectAnswer: true
						},
						key2: {
							order: 20,
							text: 'Checkbox Option2',
							isCorrectAnswer: false
						}
					}
				}
			},
			// (state) sales
			sales: {
				new: { // checkbox
					isDummy: true,

					order: 10,

					title: 'Section Title',
					text: 'Question1',

					image: {
					// 	url: 'DummyImage'
					},

					actionButtons: {
					// 	key: {
					// 		order: 1,
					// 		title: 'Title',
					// 		link: {
					// 			to: '/'
					// 		}
					// 	}
					},

					type: {
						checkbox: true,
						combobox: false,
						comboboxMultiple: false,
						radioButton: false,
						select: false, // autocomplete component
						selectMultiple: false, // autocomplete component
						slider: false,
						switch: false,
						textarea: false,
						textField: false
					},

					params: {
						appendIcon: null,
						appendOuterIcon: null,
						prependIcon: null,
						prependInnerIcon: null,

						hint: null, // for temporary hint
						message: null, // for persistent hint
						placeholder: 'Placeholder',
						prefix: null,
						suffix: null,

						mask: null, 
						// # -> number
						// a -> small letter
						// A -> big letter
						// n -> number or small letter
						// N -> number or big letter
						// date -> ##/##/####
						// time -> ##:##
						// phone -> (###)###-####
						// credit-card -> ####-####-####-####

						type: null,
						// text
						// number
						// email -> input must include '@'
						// url -> input must begin with 'http(s)://'
						// password -> masked
						// search -> clearable
						// date -> mm/dd/yyyy & calendar (value: yyyy-mm-dd)
						// datetime-local -> mm/dd/yyyy hh:mi AM/PM (value: yyyy-mm-ddThh:mi 24hrs)
						// time -> hh:mi AM/PM (value: hh:mi 24hrs)
						// month -> month yyyy (value: yyyy-mm)
						// hidden -> not shown
					},

					rules: {
						required: false,
						email: false,
						phone: false
					},

					options: {
						key1: {
							order: 10,
							text: 'Checkbox Option1'
						},
						key2: {
							order: 20,
							text: 'Checkbox Option2'
						}
					}
				}
			},
			// (state) training
			training: {
				new: {
					isDummy: true,

					order: 1,
					title: 'Card Title',
					subTitle: 'Card Sub Title',
					text: 'Card Text',
					image: {
						url: 'DummyImage'
					},
					actionButtons: {
						key: {
							order: 1,
							title: 'Action 1',
							link: {
								to: '/'
							}
						}
					},
					chips: {
						key: true
					}
				}
			},
			trainingInput_: {
				new: { // checkbox
					isDummy: true,

					order: 10,

					title: 'Section Title',
					text: 'Question1',

					image: {
						url: 'DummyImage'
					},

					actionButtons: {
					// 	key: {
					// 		order: 1,
					// 		title: 'Title',
					// 		link: {
					// 			to: '/'
					// 		}
					// 	}
					},

					type: {
						checkbox: true,
						radioButton: false,
					},

					params: {
						hint: null // always shown
					},

					rules: {
						required: false,
						email: false,
						phone: false
					},

					options: {
						key1: {
							order: 10,
							text: 'Checkbox Option1',
							isCorrectAnswer: true
						},
						key2: {
							order: 20,
							text: 'Checkbox Option2',
							isCorrectAnswer: false
						}
					},

					score: 50
				}
			},
			// (state) admin
			admin: {
				new: {
					isDummy: true,

					order: 1,

					operationType: 'new',

					tabTitle: 'Tab Title',
					title: 'Title',
					text: 'Text',
					actionButtons: {
						open: {
							order: 10,
							title: 'Upload CSV',
							link: {
								to: {
									name: 'page',
									params: {
										pageName: 'adminNewUploadCsv',
										pageType: 'csvStepper'
									}
								}
							}
						}
					},

					inputItems: {
						new: {
							order: 10,
							title: 'Input Item Title',

							type: {
								checkbox: false, // for array
								datePicker: false, // for timestamp
								radioButton: false,
								switch: false, // for boolean
								textField: true,
								// specific type
								// (for user)
								username: false,
								groupCode: false,
								// (for point)
								criteriumCode: false,
								voucherCode: false,
								// (for training)
								trainingCourseCode: false,
								trainingModuleCode: false,
								trainingSectionCode: false
							},

							options: {},

							rules: {
								email: false,
								phone: false,
								min: null,
								max: null,
								numeric: true,
								required: true
							},

							disabled: false
						}
					}
				},
				// for user
				registerUser: {
					order: 1010,

					operationType: 'user',

					tabTitle: 'Register User',
					title: 'Register User',
					text: 'Upload CSV',
					actionButtons: {
						open: {
							order: 10,
							title: 'Upload CSV',
							link: {
								to: {
									name: 'page',
									params: {
										pageName: 'adminRegisterUserUploadCsv',
										pageType: 'csvStepper'
									}
								}
							}
						}
					},

					inputItems: {
						accountType: {
							order: 10,
							title: 'Account Type',
							type: { radioButton: true },
							options: {
								username: { title: 'Username' },
								email: { title: 'Email' },
								phone: { title: 'Phone' }
							},
							rules: { required: true },
							disabled: false
						},
						username: {
							order: 20,
							title: 'Username / Email / Phone',
							type: { textField: true },
							options: {},
							rules: { required: true },
							disabled: false
						},
						password: {
							order: 30,
							title: 'Password',
							type: { textField: true },
							options: {},
							rules: { min: 8, required: true },
							disabled: false
						},
						confirmPassword: {
							order: 40,
							title: 'Confirm Password',
							type: { textField: true },
							options: {},
							rules: { min: 8, required: true },
							disabled: false
						},
						fullName: {
							order: 50,
							title: 'Full Name',
							type: { textField: true },
							options: {},
							rules: { required: true },
							disabled: false
						},
						email: {
							order: 60,
							title: 'Email',
							type: { textField: true },
							options: {},
							rules: { email: true, required: true },
							disabled: false
						},
						phone: {
							order: 70,
							title: 'Phone Number',
							type: { textField: true },
							options: {},
							rules: { phone: true },
							disabled: false
						},
						skipNewSystem: {
							order: 80,
							title: 'Skip New System',
							type: { switch: true },
							options: {},
							rules: {},
							disabled: false
						},
						skipOldSystem: {
							order: 90,
							title: 'Skip Old System',
							type: { switch: true },
							options: {},
							rules: {},
							disabled: false
						}
					}
				},
				resetPassword: {
					order: 1020,

					operationType: 'user',

					tabTitle: 'Reset Password',
					title: 'Reset Password',
					text: 'Upload CSV',
					actionButtons: {
						open: {
							order: 10,
							title: 'Upload CSV',
							link: {
								to: {
									name: 'page',
									params: {
										pageName: 'adminResetPasswordUploadCsv',
										pageType: 'csvStepper'
									}
								}
							}
						}
					},

					inputItems: {
						username: {
							order: 10,
							title: 'Username / Email / Phone',
							type: { username: true },
							options: {},
							rules: { required: true },
							disabled: false
						},
						uid: {
							order: 20,
							title: 'UID',
							type: { textField: true },
							options: {},
							rules: {},
							disabled: true
						},
						fullName: {
							order: 30,
							title: 'Full Name',
							type: { textField: true },
							options: {},
							rules: {},
							disabled: true
						},
						password: {
							order: 40,
							title: 'Password',
							type: { textField: true },
							options: {},
							rules: { min: 8, required: true },
							disabled: false
						},
						confirmPassword: {
							order: 50,
							title: 'Confirm Password',
							type: { textField: true },
							options: {},
							rules: { min: 8, required: true },
							disabled: false
						}
					}
				},
				updateUser: {
					order: 1030,

					operationType: 'user',

					tabTitle: 'Update User',
					title: 'Update User',
					text: 'Upload CSV',
					actionButtons: {
						open: {
							order: 10,
							title: 'Upload CSV',
							link: {
								to: {
									name: 'page',
									params: {
										pageName: 'adminRegisterUserUploadCsv',
										pageType: 'csvStepper'
									}
								}
							}
						}
					},

					inputItems: {
						username: {
							order: 10,
							title: 'Username / Email / Phone',
							type: { username: true },
							options: {},
							rules: { required: true },
							disabled: false
						},
						uid: {
							order: 20,
							title: 'UID',
							type: { textField: true },
							options: {},
							rules: {},
							disabled: true
						},
						fullName: {
							order: 20,
							title: 'Full Name',
							type: { textField: true },
							options: {},
							rules: { required: true },
							disabled: false
						},
						email: {
							order: 30,
							title: 'Email',
							type: { textField: true },
							options: {},
							rules: { email: true },
							disabled: false
						},
						phone: {
							order: 40,
							title: 'Phone Number',
							type: { textField: true },
							options: {},
							rules: { phone: true },
							disabled: false
						}
					}
				},
				changeUserGroup: {
					order: 1040,

					operationType: 'user',

					tabTitle: 'User Group',
					title: 'Change User Group',
					text: 'Upload CSV',
					actionButtons: {
						open: {
							order: 10,
							title: 'Upload CSV',
							link: {
								to: {
									name: 'page',
									params: {
										pageName: 'adminChangeUserGroupUploadCsv',
										pageType: 'csvStepper'
									}
								}
							}
						}
					},

					inputItems: {
						username: {
							order: 10,
							title: 'Username / Email / Phone',
							type: { username: true },
							options: {},
							rules: { required: true },
							disabled: false
						},
						uid: {
							order: 20,
							title: 'UID',
							type: { textField: true },
							options: {},
							rules: {},
							disabled: true
						},
						fullName: {
							order: 30,
							title: 'Full Name',
							type: { textField: true },
							options: {},
							rules: {},
							disabled: true
						},
						userGroupCode: {
							order: 40,
							title: 'User Group Code',
							type: { userGroupCode: true },
							options: {},
							rules: { required: true },
							disabled: false
						},
						userGroupName: {
							order: 50,
							title: 'User Group Name',
							type: { textField: true },
							options: {},
							rules: {},
							disabled: true
						},
						allocated: {
							order: 60,
							title: 'Allocated',
							type: { switch: true },
							options: {},
							rules: {},
							disabled: false
						},
						setAsMain: {
							order: 60,
							title: 'Set As Main Group',
							type: { switch: true },
							options: {},
							rules: {},
							disabled: false
						}
					}
				},
				changeUserOption: {
					order: 1050,

					operationType: 'user',

					tabTitle: 'User Option',
					title: 'Change User Option',
					text: 'Upload CSV',
					actionButtons: {
						open: {
							order: 10,
							title: 'Upload CSV',
							link: {
								to: {
									name: 'page',
									params: {
										pageName: 'adminChangeUserOptionUploadCsv',
										pageType: 'csvStepper'
									}
								}
							}
						}
					},

					inputItems: {
						username: {
							order: 10,
							title: 'Username / Email / Phone',
							type: { username: true },
							options: {},
							rules: { required: true },
							disabled: false
						},
						uid: {
							order: 20,
							title: 'UID',
							type: { textField: true },
							options: {},
							rules: {},
							disabled: true
						},
						fullName: {
							order: 30,
							title: 'Full Name',
							type: { textField: true },
							options: {},
							rules: {},
							disabled: true
						},
						resetPassword: {
							order: 40,
							title: 'Reset Password',
							type: { switch: true },
							options: {},
							rules: {},
							disabled: false
						},
						resetSecurityQuestion: {
							order: 50,
							title: 'Reset Security Question',
							type: { switch: true },
							options: {},
							rules: {},
							disabled: false
						}
					}
				},
				changeSecurityGroup: {
					order: 1060,

					operationType: 'user',

					tabTitle: 'Security Group',
					title: 'Change Security Group',
					text: 'Upload CSV',
					actionButtons: {
						open: {
							order: 10,
							title: 'Upload CSV',
							link: {
								to: {
									name: 'page',
									params: {
										pageName: 'adminChangeSecurityGroupUploadCsv',
										pageType: 'csvStepper'
									}
								}
							}
						}
					},

					inputItems: {
						username: {
							order: 10,
							title: 'Username / Email / Phone',
							type: { username: true },
							options: {},
							rules: { required: true },
							disabled: false
						},
						uid: {
							order: 20,
							title: 'UID',
							type: { textField: true },
							options: {},
							rules: {},
							disabled: true
						},
						fullName: {
							order: 30,
							title: 'Full Name',
							type: { textField: true },
							options: {},
							rules: {},
							disabled: true
						},
						securityGroupCode: {
							order: 40,
							title: 'Security Group Code',
							type: { securityGroupCode: true },
							options: {},
							rules: { required: true },
							disabled: false
						},
						securityGroupName: {
							order: 50,
							title: 'Security Group Name',
							type: { textField: true },
							options: {},
							rules: {},
							disabled: true
						}
					}
				},
				changeUserStatus: {
					order: 1070,

					operationType: 'user',

					tabTitle: 'User Status',
					title: 'Change User Status',
					text: 'Upload CSV',
					actionButtons: {
						open: {
							order: 10,
							title: 'Upload CSV',
							link: {
								to: {
									name: 'page',
									params: {
										pageName: 'adminChangeUserStatusUploadCsv',
										pageType: 'csvStepper'
									}
								}
							}
						}
					},

					inputItems: {
						username: {
							order: 10,
							title: 'Username / Email / Phone',
							type: { username: true },
							options: {},
							rules: { required: true },
							disabled: false
						},
						uid: {
							order: 20,
							title: 'UID',
							type: { textField: true },
							options: {},
							rules: {},
							disabled: true
						},
						fullName: {
							order: 30,
							title: 'Full Name',
							type: { textField: true },
							options: {},
							rules: {},
							disabled: true
						},
						blocked: {
							order: 40,
							title: 'Blocked',
							type: { switch: true },
							options: {},
							rules: {},
							disabled: false
						},
						disabled: {
							order: 50,
							title: 'Disabled',
							type: { switch: true },
							options: {},
							rules: {},
							disabled: false
						},
						confirmation: {
							order: 60,
							title: 'Check if you confirm.',
							type: { checkbox: true },
							options: {
								confirmed: { title: 'Confirmed' }
							},
							rules: { required: true },
							disabled: false
						}
					}
				},
				deleteUser: {
					order: 1080,

					operationType: 'user',

					tabTitle: 'Delete User',
					title: 'Delete User',
					text: 'Upload CSV',
					actionButtons: {
						open: {
							order: 10,
							title: 'Upload CSV',
							link: {
								to: {
									name: 'page',
									params: {
										pageName: 'adminDeleteUserUploadCsv',
										pageType: 'csvStepper'
									}
								}
							}
						}
					},
					inputItems: {
						username: {
							order: 10,
							title: 'Username / Email / Phone',
							type: { username: true },
							options: {},
							rules: { required: true },
							disabled: false
						},
						uid: {
							order: 20,
							title: 'UID',
							type: { textField: true },
							options: {},
							rules: {},
							disabled: true
						},
						fullName: {
							order: 30,
							title: 'Full Name',
							type: { textField: true },
							options: {},
							rules: {},
							disabled: true
						},
						confirmation: {
							order: 40,
							title: 'Check if you confirm.',
							type: { checkbox: true },
							options: { 
								confirmed: { title: 'Confirmed' }
							},
							rules: { required: true },
							disabled: false
						}
					}
				},
				// for group
				createGroup: {
					order: 1110,

					operationType: 'group',

					tabTitle: 'Create Group',
					title: 'Create Group',
					text: 'Upload CSV',
					actionButtons: {
						open: {
							order: 10,
							title: 'Upload CSV',
							link: {
								to: {
									name: 'page',
									params: {
										pageName: 'adminCreateGroupUploadCsv',
										pageType: 'csvStepper'
									}
								}
							}
						}
					},

					inputItems: {
						code: {
							order: 10,
							title: 'Code',
							type: { textField: true },
							options: {},
							rules: { required: true },
							disabled: false
						},
						name: {
							order: 20,
							title: 'Name',
							type: { textField: true },
							options: {},
							rules: { required: true },
							disabled: false
						},
						description: {
							order: 10,
							title: 'Description',
							type: { textField: true },
							options: {},
							rules: {},
							disabled: false
						}
					}
				},
				updateGroup: {
					order: 1120,

					operationType: 'group',

					tabTitle: 'Update Group',
					title: 'Update Group',
					text: 'Upload CSV',
					actionButtons: {
						open: {
							order: 10,
							title: 'Upload CSV',
							link: {
								to: {
									name: 'page',
									params: {
										pageName: 'adminUpdateGroupUploadCsv',
										pageType: 'csvStepper'
									}
								}
							}
						}
					},

					inputItems: {
						code: {
							order: 10,
							title: 'Code',
							type: { userGroupCode: true },
							options: {},
							rules: { required: true },
							disabled: false
						},
						name: {
							order: 20,
							title: 'Name',
							type: { textField: true },
							options: {},
							rules: { required: true },
							disabled: false
						},
						description: {
							order: 30,
							title: 'Description',
							type: { textField: true },
							options: {},
							rules: {},
							disabled: false
						}
					}
				},
				deleteGroup: {
					order: 1130,

					operationType: 'group',

					tabTitle: 'Delete Group',
					title: 'Delete Group',
					text: 'Upload CSV',
					actionButtons: {
						open: {
							order: 10,
							title: 'Upload CSV',
							link: {
								to: {
									name: 'page',
									params: {
										pageName: 'adminDeleteGroupUploadCsv',
										pageType: 'csvStepper'
									}
								}
							}
						}
					},

					inputItems: {
						code: {
							order: 10,
							title: 'Code',
							type: { userGroupCode: true },
							options: {},
							rules: { required: true },
							disabled: false
						},
						userGroupName: {
							order: 20,
							title: 'Name',
							type: { textField: true },
							options: {},
							rules: {},
							disabled: true
						},
						confirmation: {
							order: 30,
							title: 'Check if you confirm.',
							type: { checkbox: true },
							options: {
								confirmed: { title: 'Confirmed' }
							},
							rules: { required: true },
							disabled: false
						}
					}
				},
				// for point
				givePoint: {
					order: 2010,

					operationType: 'point',

					tabTitle: 'Give Point',
					title: 'Give Point',
					text: 'Upload CSV',
					actionButtons: {
						open: {
							order: 10,
							title: 'Upload CSV',
							link: {
								to: {
									name: 'page',
									params: {
										pageName: 'adminGivePointUploadCsv',
										pageType: 'csvStepper'
									}
								}
							}
						}
					},

					inputItems: {
						username: {
							order: 10,
							title: 'Username',
							type: { username: true },
							options: {},
							rules: { required: true },
							disabled: false
						},
						uid: {
							order: 20,
							title: 'UID',
							type: { textField: true },
							options: {},
							rules: {},
							disabled: true
						},
						fullName: {
							order: 30,
							title: 'Full Name',
							type: { textField: true },
							options: {},
							rules: {},
							disabled: true
						},
						amount: {
							order: 40,
							title: 'Amount',
							type: { textField: true },
							options: {},
							rules: { required: true },
							disabled: false
						},
						startDate: {
							order: 50,
							title: 'Start Date',
							type: { datePicker: true },
							options: {},
							rules: { required: true },
							disabled: false
						},
						endDate: {
							order: 60,
							title: 'End Date',
							type: { datePicker: true },
							options: {},
							rules: { required: true },
							disabled: false
						},
						criteriumCode: {
							order: 70,
							title: 'Criterium',
							type: { criteriumCode: true },
							options: {},
							rules: { required: true },
							disabled: false
						},
						criteriumName: {
							order: 80,
							title: 'Criterium Name',
							type: { textField: true },
							options: {},
							rules: {},
							disabled: true
						},
						voucherCode: {
							order: 90,
							title: 'Voucher code',
							type: { voucherCode: true },
							options: {},
							rules: {},
							disabled: false
						},
						voucherName: {
							order: 100,
							title: 'Voucher Name',
							type: { textField: true },
							options: {},
							rules: {},
							disabled: true
						},
						description: {
							order: 110,
							title: 'Description',
							type: { textField: true },
							options: {},
							rules: {},
							disabled: false
						}
					}
				},
				cancelPoint: {
					order: 2020,

					operationType: 'point',

					tabTitle: 'Cancel Point',
					title: 'Cancel Point',
					text: 'Upload CSV',
					actionButtons: {
						open: {
							order: 10,
							title: 'Upload CSV',
							link: {
								to: {
									name: 'page',
									params: {
										pageName: 'adminCancelPointUploadCsv',
										pageType: 'csvStepper'
									}
								}
							}
						}
					},

					inputItems: {
						username: {
							order: 10,
							title: 'Username',
							type: { username: true },
							options: {},
							rules: { required: true },
							disabled: false
						},
						uid: {
							order: 20,
							title: 'UID',
							type: { textField: true },
							options: {},
							rules: {},
							disabled: true
						},
						fullName: {
							order: 30,
							title: 'Full Name',
							type: { textField: true },
							options: {},
							rules: {},
							disabled: true
						},
						amount: {
							order: 40,
							title: 'Amount',
							type: { textField: true },
							options: {},
							rules: { required: true },
							disabled: false
						},
						criteriumCode: {
							order: 50,
							title: 'Criterium Code',
							type: { criteriumCode: true },
							options: {},
							rules: { required: true },
							disabled: false
						},
						criteriumName: {
							order: 60,
							title: 'Criterium Name',
							type: { textField: true },
							options: {},
							rules: {},
							disabled: true
						},
						description: {
							order: 70,
							title: 'Description',
							type: { textField: true },
							options: {},
							rules: {},
							disabled: false
						}
					}
				},
				createCriterium: {
					order: 2030,

					operationType: 'point',

					tabTitle: 'Create Criterium',
					title: 'Create Point Criterium',
					text: 'Upload CSV',
					actionButtons: {
						open: {
							order: 10,
							title: 'Upload CSV',
							link: {
								to: {
									name: 'page',
									params: {
										pageName: 'adminCreateCriteriumUploadCsv',
										pageType: 'csvStepper'
									}
								}
							}
						}
					},

					inputItems: {
						code: {
							order: 10,
							title: 'Code',
							type: { textField: true },
							options: {},
							rules: { required: true },
							disabled: false
						},
						name: {
							order: 20,
							title: 'Name',
							type: { textField: true },
							options: {},
							rules: { required: true },
							disabled: false
						},
						description: {
							order: 10,
							title: 'Description',
							type: { textField: true },
							options: {},
							rules: {},
							disabled: false
						}
					}
				},
				updateCriterium: {
					order: 2040,

					operationType: 'point',

					tabTitle: 'Update Criterium',
					title: 'Update Point Criterium',
					text: 'Upload CSV',
					actionButtons: {
						open: {
							order: 10,
							title: 'Upload CSV',
							link: {
								to: {
									name: 'page',
									params: {
										pageName: 'adminUpdateCriteriumUploadCsv',
										pageType: 'csvStepper'
									}
								}
							}
						}
					},

					inputItems: {
						code: {
							order: 10,
							title: 'Code',
							type: { criteriumCode: true },
							options: {},
							rules: { required: true },
							disabled: false
						},
						name: {
							order: 20,
							title: 'Name',
							type: { textField: true },
							options: {},
							rules: { required: true },
							disabled: false
						},
						description: {
							order: 30,
							title: 'Description',
							type: { textField: true },
							options: {},
							rules: {},
							disabled: false
						}
					}
				},
				deleteCriterium: {
					order: 2050,

					operationType: 'point',

					tabTitle: 'Delete Criterium',
					title: 'Delete Point Criterium',
					text: 'Upload CSV',
					actionButtons: {
						open: {
							order: 10,
							title: 'Upload CSV',
							link: {
								to: {
									name: 'page',
									params: {
										pageName: 'adminDeleteCriteriumUploadCsv',
										pageType: 'csvStepper'
									}
								}
							}
						}
					},

					inputItems: {
						code: {
							order: 10,
							title: 'Code',
							type: { criteriumCode: true },
							options: {},
							rules: { required: true },
							disabled: false
						},
						name: {
							order: 20,
							title: 'Name',
							type: { textField: true },
							options: {},
							rules: { required: true },
							disabled: true
						},
						description: {
							order: 30,
							title: 'Description',
							type: { textField: true },
							options: {},
							rules: {},
							disabled: true
						}
					}
				},
				createVoucher: {
					order: 2060,

					operationType: 'point',

					tabTitle: 'Create Voucher',
					title: 'Create Voucher',
					text: 'Upload CSV',
					actionButtons: {
						open: {
							order: 10,
							title: 'Upload CSV',
							link: {
								to: {
									name: 'page',
									params: {
										pageName: 'adminCreateVoucherUploadCsv',
										pageType: 'csvStepper'
									}
								}
							}
						}
					},

					inputItems: {
						code: {
							order: 10,
							title: 'Code',
							type: { textField: true },
							options: {},
							rules: { required: true },
							disabled: false
						},
						name: {
							order: 20,
							title: 'Name',
							type: { textField: true },
							options: {},
							rules: { required: true },
							disabled: false
						},
						point: {
							order: 30,
							title: 'Point',
							type: { textField: true },
							options: {},
							rules: { numeric: true, required: true },
							disabled: false
						},
						startDate: {
							order: 40,
							title: 'Start Date',
							type: { datePicker: true },
							options: {},
							rules: { required: true },
							disabled: false
						},
						endDate: {
							order: 50,
							title: 'End Date',
							type: { datePicker: true },
							options: {},
							rules: { required: true },
							disabled: false
						},
						criteriumCode: {
							order: 60,
							title: 'Criterium',
							type: { criteriumCode: true },
							options: {},
							rules: { required: true },
							disabled: false
						},
						criteriumName: {
							order: 70,
							title: 'Criterium',
							type: { textField: true },
							options: {},
							rules: { required: true },
							disabled: true
						},
						status: {
							order: 80,
							title: 'Status',
							type: { radioButton: true },
							options: {
								inactive: { title: 'Inactive' },
								active: { title: 'Active' },
								used: { title: 'Used' }
							},
							rules: { required: true },
							disabled: false
						}
					}
				},
				updateVoucher: {
					order: 2070,

					operationType: 'point',

					tabTitle: 'Update Voucher',
					title: 'Update Voucher',
					text: 'Upload CSV',
					actionButtons: {
						open: {
							order: 10,
							title: 'Upload CSV',
							link: {
								to: {
									name: 'page',
									params: {
										pageName: 'adminUpdateVoucherUploadCsv',
										pageType: 'csvStepper'
									}
								}
							}
						}
					},

					inputItems: {
						code: {
							order: 10,
							title: 'Code',
							type: { voucherCode: true },
							options: {},
							rules: { required: true },
							disabled: false
						},
						name: {
							order: 20,
							title: 'Name',
							type: { textField: true },
							options: {},
							rules: { required: true },
							disabled: false
						},
						point: {
							order: 30,
							title: 'Point',
							type: { textField: true },
							options: {},
							rules: { numeric: true, required: true },
							disabled: false
						},
						startDate: {
							order: 40,
							title: 'Start Date',
							type: { datePicker: true },
							options: {},
							rules: { required: true },
							disabled: false
						},
						endDate: {
							order: 50,
							title: 'End Date',
							type: { datePicker: true },
							options: {},
							rules: { required: true },
							disabled: false
						},
						criteriumCode: {
							order: 60,
							title: 'Criterium Code',
							type: { criteriumCode: true },
							options: {},
							rules: { required: true },
							disabled: false
						},
						criteriumName: {
							order: 70,
							title: 'Criterium Name',
							type: { textField: true },
							options: {},
							rules: { required: true },
							disabled: true
						},
						status: {
							order: 80,
							title: 'Status',
							type: { radioButton: true },
							options: {
								inactive: { title: 'Inactive' },
								active: { title: 'Active' },
								used: { title: 'Used' }
							},
							rules: { required: true },
							disabled: false
						}
					}
				},
				deleteVoucher: {
					order: 2080,

					operationType: 'point',

					tabTitle: 'Delete Voucher',
					title: 'Delete Voucher',
					text: 'Upload CSV',
					actionButtons: {
						open: {
							order: 10,
							title: 'Upload CSV',
							link: {
								to: {
									name: 'page',
									params: {
										pageName: 'adminDeleteVoucherUploadCsv',
										pageType: 'csvStepper'
									}
								}
							}
						}
					},

					inputItems: {
						code: {
							order: 10,
							title: 'Code',
							type: { voucherCode: true },
							options: {},
							rules: { required: true },
							disabled: false
						},
						name: {
							order: 20,
							title: 'Name',
							type: { textField: true },
							options: {},
							rules: {},
							disabled: true
						},
						point: {
							order: 30,
							title: 'Point',
							type: { textField: true },
							options: {},
							rules: {},
							disabled: true
						},
						startDate: {
							order: 40,
							title: 'Start Date',
							type: { datePicker: true },
							options: {},
							rules: {},
							disabled: true
						},
						endDate: {
							order: 50,
							title: 'End Date',
							type: { datePicker: true },
							options: {},
							rules: {},
							disabled: true
						},
						criteriumCode: {
							order: 60,
							title: 'Criterium Code',
							type: { textField: true },
							options: {},
							rules: {},
							disabled: true
						},
						criteriumName: {
							order: 70,
							title: 'Criterium Name',
							type: { textField: true },
							options: {},
							rules: {},
							disabled: true
						},
						status: {
							order: 80,
							title: 'Status',
							type: { radioButton: true },
							options: {
								inactive: { title: 'Inactive' },
								active: { title: 'Active' },
								used: { title: 'Used' }
							},
							rules: {},
							disabled: true
						}
					}
				},
				// for training
				openTrainingCourse: {
					order: 3010,

					operationType: 'training',

					tabTitle: 'Open Course',
					title: 'Open Training Course',
					text: 'Upload CSV',
					actionButtons: {
						open: {
							order: 10,
							title: 'Upload CSV',
							link: {
								to: {
									name: 'page',
									params: {
										pageName: 'adminOpenTrainingCourseUploadCsv',
										pageType: 'csvStepper'
									}
								}
							}
						}
					},

					inputItems: {
						username: {
							order: 10,
							title: 'Username / Email / Phone',
							type: { username: true },
							options: {},
							rules: { required: true },
							disabled: false
						},
						uid: {
							order: 20,
							title: 'UID',
							type: { textField: true },
							options: {},
							rules: {},
							disabled: true
						},
						fullName: {
							order: 30,
							title: 'Full Name',
							type: { textField: true },
							options: {},
							rules: {},
							disabled: true
						},
						trainingCourseCode: {
							order: 40,
							title: 'Course Code',
							type: { trainingCourseCode: true },
							options: {},
							rules: { required: true },
							disabled: false
						},
						trainingCourseTitle: {
							order: 50,
							title: 'Course Title',
							type: { textField: true },
							options: {},
							rules: {},
							disabled: true
						}
					}
				},
				openTrainingModule: {
					order: 3020,

					operationType: 'training',

					tabTitle: 'Open Module',
					title: 'Open Training Module',
					text: 'Upload CSV',
					actionButtons: {
						open: {
							order: 10,
							title: 'Upload CSV',
							link: {
								to: {
									name: 'page',
									params: {
										pageName: 'adminOpenTrainingModuleUploadCsv',
										pageType: 'csvStepper'
									}
								}
							}
						}
					},

					inputItems: {
						username: {
							order: 10,
							title: 'Username / Email / Phone',
							type: { username: true },
							options: {},
							rules: { required: true },
							disabled: false
						},
						uid: {
							order: 20,
							title: 'UID',
							type: { textField: true },
							options: {},
							rules: {},
							disabled: true
						},
						fullName: {
							order: 30,
							title: 'Full Name',
							type: { textField: true },
							options: {},
							rules: {},
							disabled: true
						},
						trainingCourseCode: {
							order: 40,
							title: 'Course Code',
							type: { trainingCourseCode: true },
							options: {},
							rules: { required: true },
							disabled: false
						},
						trainingCourseTitle: {
							order: 50,
							title: 'Course Title',
							type: { textField: true },
							options: {},
							rules: {},
							disabled: true
						},
						trainingModuleCode: {
							order: 60,
							title: 'Module Code',
							type: { trainingModuleCode: true },
							options: {},
							rules: { required: true },
							disabled: false
						},
						trainingModuleTitle: {
							order: 70,
							title: 'Module Title',
							type: { textField: true },
							options: {},
							rules: {},
							disabled: true
						}
					}
				},
				openTrainingSection: {
					order: 3030,

					operationType: 'training',

					tabTitle: 'Open Section',
					title: 'Open Training Section',
					text: 'Upload CSV',
					actionButtons: {
						open: {
							order: 10,
							title: 'Upload CSV',
							link: {
								to: {
									name: 'page',
									params: {
										pageName: 'adminOpenTrainingSectionUploadCsv',
										pageType: 'csvStepper'
									}
								}
							}
						}
					},

					inputItems: {
						username: {
							order: 10,
							title: 'Username / Email / Phone',
							type: { username: true },
							options: {},
							rules: { required: true },
							disabled: false
						},
						uid: {
							order: 20,
							title: 'UID',
							type: { textField: true },
							options: {},
							rules: {},
							disabled: true
						},
						fullName: {
							order: 30,
							title: 'Full Name',
							type: { textField: true },
							options: {},
							rules: {},
							disabled: true
						},
						trainingCourseCode: {
							order: 40,
							title: 'Course Code',
							type: { trainingCourseCode: true },
							options: {},
							rules: { required: true },
							disabled: false
						},
						trainingCourseTitle: {
							order: 50,
							title: 'Course Title',
							type: { textField: true },
							options: {},
							rules: {},
							disabled: true
						},
						trainingModuleCode: {
							order: 60,
							title: 'Module Code',
							type: { trainingModuleCode: true },
							options: {},
							rules: { required: true },
							disabled: false
						},
						trainingModuleTitle: {
							order: 70,
							title: 'Module Title',
							type: { textField: true },
							options: {},
							rules: {},
							disabled: true
						},
						trainingSectionCode: {
							order: 80,
							title: 'Section Code',
							type: { trainingSectionCode: true },
							options: {},
							rules: { required: true },
							disabled: false
						},
						trainingSectionTitle: {
							order: 90,
							title: 'Section Title',
							type: { textField: true },
							options: {},
							rules: {},
							disabled: true
						}
					}
				},
				closeTrainingCourse: {
					order: 3040,

					operationType: 'training',

					tabTitle: 'Close Course',
					title: 'Close Training Course',
					text: 'Upload CSV',
					actionButtons: {
						open: {
							order: 10,
							title: 'Upload CSV',
							link: {
								to: {
									name: 'page',
									params: {
										pageName: 'adminCloseTrainingCourseUploadCsv',
										pageType: 'csvStepper'
									}
								}
							}
						}
					},

					inputItems: {
						username: {
							order: 10,
							title: 'Username / Email / Phone',
							type: { username: true },
							options: {},
							rules: { required: true },
							disabled: false
						},
						uid: {
							order: 20,
							title: 'UID',
							type: { textField: true },
							options: {},
							rules: {},
							disabled: true
						},
						fullName: {
							order: 30,
							title: 'Full Name',
							type: { textField: true },
							options: {},
							rules: {},
							disabled: true
						},
						trainingCourseCode: {
							order: 40,
							title: 'Course Code',
							type: { trainingCourseCode: true },
							options: {},
							rules: { required: true },
							disabled: false
						},
						trainingCourseTitle: {
							order: 50,
							title: 'Course Title',
							type: { textField: true },
							options: {},
							rules: {},
							disabled: true
						}
					}
				},
				closeTrainingModule: {
					order: 3050,

					operationType: 'training',

					tabTitle: 'Close Module',
					title: 'Close Training Module',
					text: 'Upload CSV',
					actionButtons: {
						open: {
							order: 10,
							title: 'Upload CSV',
							link: {
								to: {
									name: 'page',
									params: {
										pageName: 'adminCloseTrainigModuleUploadCsv',
										pageType: 'csvStepper'
									}
								}
							}
						}
					},

					inputItems: {
						username: {
							order: 10,
							title: 'Username / Email / Phone',
							type: { username: true },
							options: {},
							rules: { required: true },
							disabled: false
						},
						uid: {
							order: 20,
							title: 'UID',
							type: { textField: true },
							options: {},
							rules: {},
							disabled: true
						},
						fullName: {
							order: 30,
							title: 'Full Name',
							type: { textField: true },
							options: {},
							rules: {},
							disabled: true
						},
						trainingCourseCode: {
							order: 40,
							title: 'Course Code',
							type: { trainingCourseCode: true },
							options: {},
							rules: { required: true },
							disabled: false
						},
						trainingCourseTitle: {
							order: 50,
							title: 'Course Title',
							type: { textField: true },
							options: {},
							rules: {},
							disabled: true
						},
						trainingModuleCode: {
							order: 60,
							title: 'Module Code',
							type: { trainingModuleCode: true },
							options: {},
							rules: { required: true },
							disabled: false
						},
						trainingModuleTitle: {
							order: 70,
							title: 'Module Title',
							type: { textField: true },
							options: {},
							rules: {},
							disabled: true
						}
					}
				},
				closeTrainingSection: {
					order: 3060,

					operationType: 'training',

					tabTitle: 'Close Section',
					title: 'Close Training Section',
					text: 'Upload CSV',
					actionButtons: {
						open: {
							order: 10,
							title: 'Upload CSV',
							link: {
								to: {
									name: 'page',
									params: {
										pageName: 'adminCloseTrainingSectionUploadCsv',
										pageType: 'csvStepper'
									}
								}
							}
						}
					},

					inputItems: {
						username: {
							order: 10,
							title: 'Username / Email / Phone',
							type: { username: true },
							options: {},
							rules: { required: true },
							disabled: false
						},
						uid: {
							order: 20,
							title: 'UID',
							type: { textField: true },
							options: {},
							rules: {},
							disabled: true
						},
						fullName: {
							order: 30,
							title: 'Full Name',
							type: { textField: true },
							options: {},
							rules: {},
							disabled: true
						},
						trainingCourseCode: {
							order: 40,
							title: 'Course Code',
							type: { trainingCourseCode: true },
							options: {},
							rules: { required: true },
							disabled: false
						},
						trainingCourseTitle: {
							order: 50,
							title: 'Course Title',
							type: { textField: true },
							options: {},
							rules: {},
							disabled: true
						},
						trainingModuleCode: {
							order: 60,
							title: 'Module Code',
							type: { trainingModuleCode: true },
							options: {},
							rules: { required: true },
							disabled: false
						},
						trainingModuleTitle: {
							order: 70,
							title: 'Module Title',
							type: { textField: true },
							options: {},
							rules: {},
							disabled: true
						},
						trainingSectionCode: {
							order: 80,
							title: 'Section Code',
							type: { trainingSectionCode: true },
							options: {},
							rules: { required: true },
							disabled: false
						},
						trainingSectionTitle: {
							order: 90,
							title: 'Section Title',
							type: { textField: true },
							options: {},
							rules: {},
							disabled: true
						}
					}
				},
				// for notification
				sendEmailNotification: {
					order: 10010,

					operationType: 'notification',

					tabTitle: 'Send Email',
					title: 'Send Email Notification',
					text: 'Upload CSV',
					actionButtons: {
						open: {
							order: 10,
							title: 'Upload CSV',
							link: {
								to: {
									name: 'page',
									params: {
										pageName: 'adminSendEmailNotificationUploadCsv',
										pageType: 'csvStepper'
									}
								}
							}
						}
					},

					inputItems: {
						username: {
							order: 10,
							title: 'Username / Email / Phone',
							type: { username: true },
							options: {},
							rules: { required: true },
							disabled: false
						},
						uid: {
							order: 20,
							title: 'UID',
							type: { textField: true },
							options: {},
							rules: {},
							disabled: true
						},
						fullName: {
							order: 30,
							title: 'Full Name',
							type: { textField: true },
							options: {},
							rules: {},
							disabled: true
						},
						email: {
							order: 40,
							title: 'Email (To)',
							type: { textField: true },
							options: {},
							rules: { email: true },
							disabled: false
						},
						from: {
							order: 50,
							title: 'Email (From)',
							type: { textField: true },
							options: {},
							rules: { email: true, required: true },
							disabled: false
						},
						cc: {
							order: 60,
							title: 'Email (Cc)',
							type: { textField: true },
							options: {},
							rules: { email: true },
							disabled: false
						},
						bcc: {
							order: 70,
							title: 'Email (Bcc)',
							type: { textField: true },
							options: {},
							rules: { email: true },
							disabled: false
						},
						subject: {
							order: 80,
							title: 'Subject',
							type: { textField: true },
							options: {},
							rules: { required: true },
							disabled: false
						},
						html: {
							order: 90,
							title: 'HTML',
							type: { textareaMarkdown: true },
							options: {},
							rules: { required: true },
							disabled: false
						}
					}
				},
				sendSmsNotification: {
					order: 10020,

					operationType: 'notification',

					tabTitle: 'Send SMS',
					title: 'Send SMS Notification',
					text: 'Upload CSV',
					actionButtons: {
						open: {
							order: 10,
							title: 'Upload CSV',
							link: {
								to: {
									name: 'page',
									params: {
										pageName: 'adminSendSmsNotificationUploadCsv',
										pageType: 'csvStepper'
									}
								}
							}
						}
					},

					inputItems: {
						username: {
							order: 10,
							title: 'Username / Email / Phone',
							type: { username: true },
							options: {},
							rules: { required: true },
							disabled: false
						},
						uid: {
							order: 20,
							title: 'UID',
							type: { textField: true },
							options: {},
							rules: {},
							disabled: true
						},
						fullName: {
							order: 30,
							title: 'Full Name',
							type: { textField: true },
							options: {},
							rules: {},
							disabled: true
						},
						phone: {
							order: 40,
							title: 'Phone',
							type: { textField: true },
							options: {},
							rules: { phone: true },
							disabled: false
						},
						text: {
							order: 50,
							title: 'Text',
							type: { textarea: true },
							options: {},
							rules: { required: true },
							disabled: false
						}
					}
				},
				sendPushNotification: {
					order: 10030,

					operationType: 'notification',

					tabTitle: 'Send Push',
					title: 'Send Push Notification',
					text: 'Upload CSV',
					actionButtons: {
						open: {
							order: 10,
							title: 'Upload CSV',
							link: {
								to: {
									name: 'page',
									params: {
										pageName: 'adminSendPushNotificationUploadCsv',
										pageType: 'csvStepper'
									}
								}
							}
						}
					},

					inputItems: {
						username: {
							order: 10,
							title: 'Username / Email / Phone',
							type: { username: true },
							options: {},
							rules: { required: true },
							disabled: false
						},
						uid: {
							order: 20,
							title: 'UID',
							type: { textField: true },
							options: {},
							rules: {},
							disabled: true
						},
						fullName: {
							order: 30,
							title: 'Full Name',
							type: { textField: true },
							options: {},
							rules: {},
							disabled: true
						},
						title: {
							order: 40,
							title: 'Title',
							type: { textField: true },
							options: {},
							rules: { required: true },
							disabled: false
						},
						text: {
							order: 50,
							title: 'Text',
							type: { textField: true },
							options: {},
							rules: { required: true },
							disabled: false
						},
						url: {
							order: 60,
							title: 'URL',
							type: { textField: true },
							options: {},
							rules: { required: true },
							disabled: false
						}
					}
				}
			},
			adminChatWork: {
				chatWork: {
					order: 10,

					subTitle: 'ChatWork',
					text: '- Please register task if you find any problem or error in the system.\n- Username and password for chatwork is created by Benefit One.\n- Please adk Dewi if you forget your username and password for chatwork.\n- Benefit One will input duedate to each task **within 24 hours** after it is registered.\n- Benefit One will report in chatwork about the development progress **24 hours before** the duedate.\n- Benefit One will keep on updating about the development progress until the task is finished.<br><br><a href="https://support-en.chatwork.com/hc/en-us/articles/201376099-Assigning-editing-deleting-tasks" target="_blank"><h3>How to register a task</h3></a>',

					actionButtons: {
						open: {
							order: 10,
							title: 'Open ChatWork',
							link: {
								url: 'https://www.chatwork.com/login.php?lang=en'
							}
						}
					}
				}
			},
			adminRegisterUserUploadCsv: {
				accountType: {
					order: 10,

					headerText: 'Account Type',

					isNullable: false,

					dataType: { string: true }
				},
				username: {
					order: 20,

					headerText: 'Username/Email/Phone',

					isNullable: false,

					dataType: { string: true }
				},
				password: {
					order: 30,

					headerText: 'Password',

					isNullable: false,

					dataType: { string: true }
				},
				confirmPassword: {
					order: 40,

					headerText: 'Confirm Password',

					isNullable: false,

					dataType: { string: true }
				},
				fullName: {
					order: 50,

					headerText: 'Full Name',

					isNullable: false,

					dataType: { string: true }
				},
				email: {
					order: 60,

					headerText: 'Email',

					isNullable: false,

					dataType: { string: true }
				},
				phone: {
					order: 70,

					headerText: 'Phone Number',

					isNullable: false,

					dataType: { string: true }
				},
				skipNewSystem: {
					order: 80,

					headerText: 'Skip New System',

					isNullable: false,

					dataType: { boolean: true }
				},
				skipOldSystem: {
					order: 90,

					headerText: 'Skip Old System',

					isNullable: false,

					dataType: { boolean: true }
				}
			},
			adminResetPasswordUploadCsv: {
				username: {
					order: 10,

					headerText: 'Username/Email/Phone',

					isNullable: false,

					dataType: { string: true }
				},
				password: {
					order: 20,

					headerText: 'Password',

					isNullable: false,

					dataType: { string: true }
				},
				confirmPassword: {
					order: 30,

					headerText: 'Confirm Password',

					isNullable: false,

					dataType: { string: true }
				}
			},
			adminUpdateUserUploadCsv: {
				username: {
					order: 10,

					headerText: 'Username/Email/Phone',

					isNullable: false,

					dataType: { string: true }
				},
				fullName: {
					order: 20,

					headerText: 'Full Name',

					isNullable: false,

					dataType: { string: true }
				},
				email: {
					order: 30,

					headerText: 'Email',

					isNullable: false,

					dataType: { string: true }
				},
				phone: {
					order: 40,

					headerText: 'Phone Number',

					isNullable: false,

					dataType: { string: true }
				}
			},
			adminChangeUserGroupUploadCsv: {
				username: {
					order: 10,

					headerText: 'Username/Email/Phone',

					isNullable: false,

					dataType: { string: true }
				},
				userGroupCode: {
					order: 20,

					headerText: 'Group Code',

					isNullable: false,

					dataType: { string: true }
				},
				allocated: {
					order: 30,

					headerText: 'Allocated',

					isNullable: false,

					dataType: { boolean: true }
				},
				setAsMain: {
					order: 30,

					headerText: 'Set As Main Group',

					isNullable: false,

					dataType: { boolean: true }
				}
			},
			adminChangeUserOptionUploadCsv: {
				username: {
					order: 10,

					headerText: 'Username/Email/Phone',

					isNullable: false,

					dataType: { string: true }
				},
				resetPassword: {
					order: 20,

					headerText: 'Reset Password',

					isNullable: false,

					dataType: { string: true }
				},
				resetSecurityQuestion: {
					order: 30,

					headerText: 'Reset Security Question',

					isNullable: false,

					dataType: { string: true }
				}
			},
			adminChangeSecurityGroupUploadCsv: {
				username: {
					order: 10,

					headerText: 'Username/Email/Phone',

					isNullable: false,

					dataType: { string: true }
				},
				securityGroupCode: {
					order: 20,

					headerText: 'Security Group Code',

					isNullable: false,

					dataType: { string: true }
				}
			},
			adminChangeUserStatusUploadCsv: {
				username: {
					order: 10,

					headerText: 'Username/Email/Phone',

					isNullable: false,

					dataType: { string: true }
				},
				blocked: {
					order: 20,

					headerText: 'Password',

					isNullable: false,

					dataType: { string: true }
				},
				disabled: {
					order: 30,

					headerText: 'Password',

					isNullable: false,

					dataType: { string: true }
				},
				confirmation: {
					order: 40,

					headerText: 'Confirmation',

					isNullable: false,

					dataType: { string: true }
				}
			},
			adminDeleteUserUploadCsv: {
				username: {
					order: 10,

					headerText: 'Username/Email/Phone',

					isNullable: false,

					dataType: { string: true }
				},
				confirmation: {
					order: 20,

					headerText: 'Confirmation',

					isNullable: false,

					dataType: { string: true }
				}
			},
			adminCreateGroupUploadCsv: {
				code: {
					order: 10,

					headerText: 'Group Code',

					isNullable: false,

					dataType: { string: true }
				},
				name: {
					order: 20,

					headerText: 'Group Name',

					isNullable: false,

					dataType: { string: true }
				},
				description: {
					order: 30,

					headerText: 'Description',

					isNullable: false,

					dataType: { string: true }
				}
			},
			adminUpdateGroupUploadCsv: {
				code: {
					order: 10,

					headerText: 'Group Code',

					isNullable: false,

					dataType: { string: true }
				},
				name: {
					order: 20,

					headerText: 'Group Name',

					isNullable: false,

					dataType: { string: true }
				},
				description: {
					order: 30,

					headerText: 'Description',

					isNullable: false,

					dataType: { string: true }
				}
			},
			adminDeleteGroupUploadCsv: {
				code: {
					order: 10,

					headerText: 'Group Code',

					isNullable: false,

					dataType: { string: true }
				},
				confirmation: {
					order: 30,

					headerText: 'Confirmation',

					isNullable: false,

					dataType: { string: true }
				}
			},
			adminCreateVoucherUploadCsv: {
				code: {
					order: 10,

					headerText: 'Voucher Code',

					isNullable: false,

					dataType: { string: true }
				},
				name: {
					order: 20,

					headerText: 'Voucher Name',

					isNullable: false,

					dataType: { string: true }
				},
				point: {
					order: 30,

					headerText: 'Point',

					isNullable: false,

					dataType: { integer: true }
				},
				startDate: {
					order: 40,

					headerText: 'Start Date',

					isNullable: false,

					dataType: { date: true }
				},
				endDate: {
					order: 50,

					headerText: 'End Date',

					isNullable: false,

					dataType: { date: true }
				},
				criteriumCode: {
					order: 60,

					headerText: 'Criterium Code',

					isNullable: false,

					dataType: { string: true }
				},
				status: {
					order: 70,

					headerText: 'Status',

					isNullable: false,

					dataType: { string: true }
				},
			},
			adminSendEmailNotificationUploadCsv: {
				username: {
					order: 10,

					headerText: 'Username/Email/Phone',

					isNullable: false,

					dataType: { string: true }
				},
				from: {
					order: 20,

					headerText: 'Email (from)',

					isNullable: false,

					dataType: { string: true }
				},
				cc: {
					order: 30,

					headerText: 'Email (Cc)',

					isNullable: true,

					dataType: { string: true }
				},
				bcc: {
					order: 40,

					headerText: 'Email (Bcc)',

					isNullable: true,

					dataType: { string: true }
				},
				subject: {
					order: 50,

					headerText: 'Subject',

					isNullable: false,

					dataType: { string: true }
				},
				html: {
					order: 60,

					headerText: 'HTML',

					isNullable: false,

					dataType: { string: true }
				}
			},
			adminSendSmsNotificationUploadCsv: {
				username: {
					order: 10,

					headerText: 'Username/Email/Phone',

					isNullable: false,

					dataType: { string: true }
				},
				text: {
					order: 20,

					headerText: 'Text',

					isNullable: false,

					dataType: { string: true }
				}
			},
			adminSendPushNotificationUploadCsv: {
				username: {
					order: 10,

					headerText: 'Username/Email/Phone',

					isNullable: false,

					dataType: { string: true }
				},
				title: {
					order: 20,

					headerText: 'Title',

					isNullable: false,

					dataType: { string: true }
				},
				text: {
					order: 30,

					headerText: 'Text',

					isNullable: false,

					dataType: { string: true }
				},
				url: {
					order: 40,

					headerText: 'URL',

					isNullable: false,

					dataType: { string: true }
				}
			},
			// (state) security question
			securityQuestion: {
				Q1: {
					order: 10,
					options: {
						option1: {
							order: 10,
							text: 'What is the name of your pet?'
						},
						option2: {
							order: 20,
							text: 'What is the title of your favorite game?'
						},
						option3: {
							order: 30,
							text: 'What is the title of your favorite movie?'
						},
						option4: {
							order: 40,
							text: 'What is the title of your favorite book?'
						}
					}
				},
				Q2: {
					order: 20,
					options: {
						option1: {
							order: 10,
							text: 'What is your hobby?'
						},
						option2: {
							order: 20,
							text: 'What is your morning custom?'
						},
						option3: {
							order: 30,
							text: 'What is your job?'
						},
						option4: {
							order: 40,
							text: 'What is your special skill?'
						}
					}
				},
				Q3: {
					order: 30,
					options: {
						option1: {
							order: 10,
							text: 'Where do you come from?'
						},
						option2: {
							order: 20,
							text: 'Where is your elementary school?'
						},
						option3: {
							order: 30,
							text: 'Where is your high school?'
						},
						option4: {
							order: 40,
							text: 'Where is your favorite place to travel?'
						}
					}
				}
			}
		}
	},

	getters: {
		get: state => state
	},

	mutations: {
		setValue (state, [key, value]) {
			state[key] = value;
		},
		setSubValue (state, [key, subKey, value]) {
			state[key][subKey] = value;
		}
	},

	actions: {
	}
}
